/* global axios */
import ApiClient from '../ApiClient';

class WgptAutomationRegistryAPI extends ApiClient {
  constructor() {
    super('automation_registry', {
      accountScoped: true,
      wgpt: true,
    });
  }

  getDynamicOptions(fieldName, params) {
    return axios.get(`${this.url}/dynamic_options/${fieldName}`, { params });
  }

  getDynamicArrays(fieldName, params) {
    return axios.get(`${this.url}/dynamic_arrays/${fieldName}`, { params });
  }

  getDynamicFlags(flagName, params) {
    return axios.get(`${this.url}/dynamic_flags/${flagName}`, { params });
  }

  getCustomOptions(fieldName, params) {
    return axios.get(`${this.url}/custom_options/${fieldName}`, { params });
  }

  getCustomObjects(objectName) {
    return axios.get(`${this.url}/custom_objects/${objectName}`);
  }

  getTriggers() {
    return axios.get(`${this.url}/triggers`);
  }

  getActions(triggerId) {
    return axios.get(`${this.url}/triggers/${triggerId}/actions`);
  }

  getLogicalOperators() {
    return axios.get(`${this.url}/logical_operators`);
  }

  getComparisonOperators() {
    return axios.get(`${this.url}/comparison_operators`);
  }

  getTemplates() {
    return axios.get(`${this.url}/templates`);
  }
}

export default new WgptAutomationRegistryAPI();
